import { OccupancyRateTableFiltersActionTypes, OccupancyRateTableFiltersState, SET_OCCUPANCY_RATE_TABLE_FILTERS } from "store/reducers/room/occupancyRateTableFilters/types";

const defaultState: OccupancyRateTableFiltersState = {
  isLoading: false,
  errorMessage: "",
  contents: {},
  exists: false,
};

export default function occupancyRateTableFilters(state = defaultState, action: OccupancyRateTableFiltersActionTypes): OccupancyRateTableFiltersState {
  switch (action.type) {
    case SET_OCCUPANCY_RATE_TABLE_FILTERS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        exists: action.exists,
      };
    default:
      return state;
  }
}
